module.exports = __webpack_public_path__ + "img/Now-Logo.b8e65bee.png";